
<template>
  <div>
    <loading
      :active.sync="loadingTicket"
      :is-full-page="true"
      color="green"
    ></loading>
    <v-card flat>
      <v-card-text>
        <v-layout>
          <v-flex xs8 mx-2>
            <v-card flat>
              <h3 class="mt-2 grey--text" style="text-align: left">
                Ticket: {{ ticketItem.id }}
              </h3>
              <h4
                class="grey--text"
                style="text-align: left; word-wrap: break-word"
              >
                {{ ticketItem.description }}
              </h4>

              <h4 class="mt-3 grey--text" style="text-align: left">
                Please add your comments below
              </h4>
              <at-ta :members="members">
                <v-textarea
                  class="mt-3"
                  v-on:keyup.enter="addCommentEditedTicket(comment)"
                  outline
                  auto-grow
                  v-model="comment"
                ></v-textarea>
              </at-ta>
            </v-card>
            <v-card flat style="overflow-y: auto; max-height: 1000px">
              <v-container style="text-align: left">
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="item in logArray"
                    :key="item.id"
                  >
                    <h3 class="grey--text font-weight-light">
                      {{ formatDateTime(item.createdAt) }}
                    </h3>
                    <v-layout
                      v-if="item.commentLogType == false"
                      text-xs-center
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            v-on="on"
                            size="30px"
                            color="primary"
                            class="mx-1 font-weight-light white--text"
                            v-if="item !== 'undefined'"
                            >{{ item.assignedByName.charAt(0)
                            }}{{ item.assignedBySurname.charAt(0) }}</v-avatar
                          >
                        </template>
                        <span class="font-weight-light"
                          >{{ item.assignedByName }}
                          {{ item.assignedBySurname }}</span
                        >
                      </v-tooltip>
                      <span class="mx-1 mt-1 grey--text font-weight-light">
                        assigned the ticket to
                      </span>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            v-on="on"
                            size="30px"
                            color="primary"
                            class="mx-1 font-weight-light white--text"
                            v-if="item !== 'undefined'"
                            >{{ item.assignedToName.charAt(0)
                            }}{{ item.assignedToSurname.charAt(0) }}</v-avatar
                          >
                        </template>
                        <span class="font-weight-light"
                          >{{ item.assignedToName }}
                          {{ item.assignedToSurname }}</span
                        >
                      </v-tooltip>
                    </v-layout>
                    <v-layout v-else>
                      <span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="30px"
                              color="primary"
                              style="width: 30px"
                              class="mx-1 font-weight-light white--text"
                              v-if="item !== 'undefined'"
                              >{{ item.commentedByName.charAt(0)
                              }}{{
                                item.commentedBySurname.charAt(0)
                              }}</v-avatar
                            >
                          </template>
                          <span class="font-weight-light"
                            >{{ item.commentedByName }}
                            {{ item.commentedBySurname }}</span
                          >
                        </v-tooltip></span
                      >
                      <span
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light"
                        >{{ item.comment }}</span
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs4 mx-2>
            <br /><br /><br />
            <v-layout>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Due Date:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ formatDate(ticketItem.dueDate) }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout v-if="ticketItem.dueTime">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Due Time:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.dueTime }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout v-if="ticketItem.ticketCategoryItemId">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Category:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.ticketCategoryItem.ticketCategory.name }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout v-if="ticketItem.ticketCategoryItemId">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Subcategory:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.ticketCategoryItem.name }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout v-if="ticketItem.currentStatus">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Status:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3 style="text-align: left" class="grey--text">
                  <v-chip
                    small
                    :class="`${ticketItem.currentStatus
                      .replace(/\s/g, '')
                      .toLowerCase()} white--text`"
                    >{{ ticketItem.currentStatus }}</v-chip
                  >
                </h3>
              </v-flex>
            </v-layout>
            <v-layout v-if="ticketItem.importance">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Importance:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3 style="text-align: left" class="grey--text">
                  <v-chip
                    small
                    :class="`${ticketItem.importance
                      .replace(/\s/g, '')
                      .toLowerCase()} white--text`"
                    >{{ ticketItem.importance }}</v-chip
                  >
                </h3>
              </v-flex>
            </v-layout>

            <v-layout v-if="ticketItem.serviceLevelAgreementId">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Service Level Agreement:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.serviceLevelAgreement.name }}
                </h3>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="
                !ticketItem.serviceLevelAgreementId && ticketItem.locationId
              "
            >
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  End Location:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.location.locationDescription }}
                </h3>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="
                !ticketItem.serviceLevelAgreementId &&
                ticketItem.switchingCentreId
              "
            >
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Switching Centre:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.switchingCentre.name }}
                </h3>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="
                !ticketItem.serviceLevelAgreementId && ticketItem.locationNodeId
              "
            >
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Location Node:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.locationNode.name }}
                </h3>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="
                !ticketItem.serviceLevelAgreementId &&
                ticketItem.locationNetworkId
              "
            >
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Location Network:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.locationNetwork.name }}
                </h3>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="
                ticketItem.serviceLevelAgreementId &&
                ticketItem.locationNetworkId
              "
            >
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Location Network:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.locationNetwork.name }}
                </h3>
              </v-flex>
            </v-layout>

            <!-- <v-layout v-if="ticketItem.assignedToId">
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  Assigned To:
                </h3>
              </v-flex>
              <v-flex xs6 mx-2>
                <h3
                  style="text-align: left"
                  class="mt-1 grey--text font-weight-light"
                >
                  {{ ticketItem.assignedTo.name }}
                  {{ ticketItem.assignedTo.surname }}
                </h3>
              </v-flex>
            </v-layout> -->
             <v-layout v-if="ticketItem.serviceAccountId">
              <v-flex xs12 my-1>
                <v-card hover color="white" @click="redirectServiceAccount()">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Service Account:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Circuit Number:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.serviceAccount.circuitNumber}}</span></v-flex>
                      </v-layout>
                      <!-- <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">ISP:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.serviceAccount.customerOrganisation.name}}</span></v-flex>
                      </v-layout> -->
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
            <v-layout v-if="ticketItem.deviceId">
              <v-flex xs12 my-1>
                <v-card color="white">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Device Details:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Make/Model:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.device.deviceMakeModel.deviceMake.name}} {{ticketItem.device.deviceMakeModel.name}}</span></v-flex>
                      </v-layout>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Pon MAC:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.device.ponMac}}</span></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Calendar from "v-calendar/lib/components/calendar.umd";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea

export default {
  components: {
    Calendar,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    loading: Loading,
    At,
    AtTa,
  },
  data() {
    return {
      customerEmailAddressArray: [],
      mentioned: null,
      emailAddressArray: [],
      emailTemplate: "",
      membersEmail: [],
      pagination: {},
      locationLength: 0,
      page: 1,
      text: "",
      theWholeText: "",
      members: [],
      slaId: null,
      slaItems: [],
      loadingTicket: false,
      switchingCentres: [],
      locationNetworks: [],
      locationNodes: [],
      logArray: [],
      addTemplate: false,
      ticketTemplates: [],
      isLoading: true,
      search: "",
      newDay: this.formatDate(new Date()),
      contactTableId: null,
      contacts: [],
      contactId: null,
      cardsPerPage: 2,
      resultCount: 0,
      currentPage: 1,
      activeTabName: "",
      key: 0,
      addTicketModal: false,
      editTicketModal: false,
      datePicker: false,
      timePicker: false,
      dateTimeSelect: true,
      addLocationModal: false,
      over: false,
      ticketItem: {},
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredLocations: [],
      filteredTickets: [],
      locationFilter: null,
      userSearch: "",
      comment: "",
      overData: null,
      initialAssignedId: null,
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      locationType: "",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      today: this.formatDate(new Date()),
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
    };
  },
  created() {
    this.fetchTickets();
    this.fetchOrgContacts();
  },
  methods: {
    redirectServiceAccount(){
      this.$router.push({ path: "/isp/serviceAccounts/" + this.ticketItem.serviceAccountId });

    },
    fetchTicketComments(id) {
      Api()
        .get("/ispTicketComment/byTicket/" + id)
        .then(async (response) => {
          this.ticketCommentLog = response.data;
          if (this.ticketCommentLog.length > 0) {
            await this.ticketCommentLog.map((x) => {
              this.logArray.push({
                commentedById: x.commentedById,
                commentedByName: x.commentedBy.name,
                commentedBySurname: x.commentedBy.surname,
                comment: x.comment,
                type: x.type,
                createdAt: x.createdAt,
                id: x.id,
                commentLogType: true,
              });
            });
            this.logArray.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
          }
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then(async (response) => {
          this.ticketAssignedLog = response.data;
          if (this.ticketAssignedLog.length > 0) {
            await this.ticketAssignedLog.map((x) => {
              this.logArray.push({
                assignedById: x.assignedById,
                assignedByName: x.assignedBy.name,
                assignedBySurname: x.assignedBy.surname,
                assignedToId: x.assignedToId,
                assignedToName: x.assignedTo.name,
                assignedToSurname: x.assignedTo.surname,
                createdAt: x.createdAt,
                id: x.id,
                commentLogType: false,
              });
            });
            this.logArray.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
          }
          this.loadingTicket = false;
        });
    },

    async addCommentEditedTicket(comment) {
      this.mentioned = this.members.filter((x) => comment.includes(x));
      await this.mentioned.map((y) => {
        this.membersEmail.map((x) => {
          if (x.fullName === y) {
            this.customerEmailAddressArray.push(x.email);
          }
        });
      });
      Api()
        .post("/ticketComment", {
          isInternal: false,
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          if (this.ticketItem.createdBy.permissions == "FNO Operator") {
            this.emailAddressArray.push(this.ticketItem.createdBy.emailAddress);
          } else {
            this.customerEmailAddressArray.push(
              this.ticketItem.createdBy.emailAddress
            );
          }

          if (this.ticketItem.assignedToId) {
            this.emailAddressArray.push(
              this.ticketItem.assignedTo.emailAddress
            );
          }
          let emailArray = [
            ...new Set(this.emailAddressArray.map((item) => item)),
          ];
          Api()
            .post("/ticketNotification/mailgun", {
              ticket: this.ticketItem,
              organisation: this.$store.state.currentOrg.org,
              emailAddressArray: emailArray,
              subject: "Reply Made to Ticket: " + this.ticketItem.id,
            })
            .then((response) => {
              this.emailAddressArray = [];
            });

          if (this.customerEmailAddressArray.length > 0) {
            let emailArray = [
              ...new Set(this.customerEmailAddressArray.map((item) => item)),
            ];
            Api()
              .post("/ticketNotification/mailgun", {
                ticket: this.ticketItem,
                organisation: this.$store.state.currentOrg.org,
                emailAddressArray: emailArray,
                subject: "Reply Made to Ticket: " + this.ticketItem.id,
              })
              .then((response) => {
                this.customerEmailAddressArray = [];
              });
          }

          this.fetchTickets();
          this.key++;
          this.comment = "";
        });
    },
    filterObject(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.surname
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatTime(date) {
      if (date !== null) {
        return dateformat(date, "HH:MM");
      } else {
        null;
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    async fetchTickets() {
      this.loadingTicket = true;
      Api()
        .get("/isp/ticket/" + this.$route.params.ticketId)
        .then(async (response) => {
          this.ticketItem = response.data;
          // this.ticketItem.locationId = response.data.locationId
          // this.ticketItem.locationNetworkId = response.data.locationNetworkId
          // this.ticketItem.locationNodeId = response.data.locationNodeId
          // this.ticketItem.switchingCentreId = response.data.switchingCentreId
          // this.ticketItem.ticketCategoryId = response.data.ticketCategoryItem.ticketCategoryId
          // if(this.ticketItem.locationId){
          // this.ticketItem.location.locationDescription = response.data.location.locationDescription
          // }
          // if(this.ticketItem.locationNodeId){
          // this.ticketItem.locationNode.name = response.data.locationNode.name
          // }
          this.logArray = [];
          this.fetchTicketComments(this.ticketItem.id);
          this.fetchTicketAssignments(this.ticketItem.id);
        });
    },
    sortedDate(date) {
      return (
        new Date(date.toDateString()) >= new Date(new Date().toDateString())
      );
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data.filter(function (el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map((x) => x.contact);
          this.members = await contactArray.map(
            (x) => x.name + " " + x.surname
          );
          await contactArray.map((x) => {
            this.membersEmail.push({
              fullName: x.name + " " + x.surname,
              email: x.emailAddress,
            });
          });
          this.filteredUsers = contactArray;
        });
    },
  },
};
</script>
<style>
.commentSpan {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
</style>